<template lang="html">
	<div class="test-radio">
		<div class="row">
			<div :class="form.class">
				<Radio
					:classes="form.classes"
					:name="form.model"
					v-model="radio"
					:action="form.name"
					:placeholder="form.placeholder"
					:options="form.options"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
		Radio: () => import('@/libs/clarks/components/radio'),
	},
	data() {
		return {
			radio: '',
			form: {
				class: 'col-4 advanced-radio',
				classes: { radioRow: 'row', radioCol: 'col-12' },
				name: 'Check Bank',
				placeholder: 'Check Bank',
				options: [
					{
						val: 'Equity',
						label: '<div class="bank-group clearfix"><div class="image-group"><img src="https://i0.wp.com/www.africanbusinesscentral.com/wp-content/uploads/2014/07/equity-bank.jpg?fit=670%2C423&ssl=1&resize=1280%2C720" class="image"></div><div class="text">Equity Bank</div></div>',
					},
					{
						val: 'Stanbic',
						label: '<div class="bank-group clearfix"><div class="image-group"><img src="https://sokodirectory.com/wp-content/uploads/2020/03/Stanbic-Bank.jpg" class="image"></div><div class="text">Stanbic Bank</div></div>',
					},
					{
						val: 'Corparative',
						label: '<div class="bank-group clearfix"><div class="image-group"><img src="https://i0.wp.com/images.africanfinancials.com/ke-coop-logo-min.png?resize=600%2C9999&ssl=1" class="image"></div><div class="text">Corparative Bank</div></div>',
					},
					{
						val: 'Family',
						label: '<div class="bank-group clearfix"><div class="image-group"><img src="https://familybank.co.ke/family-bank/wp-content/themes/family-bank/assets/images/family-bank-logo-600px.png" class="image"></div><div class="text">Family Bank</div></div>',
					},
				],
			},
		};
	},
	methods: {
		get(url) {},
	},
	mounted() {
		Event.$emit('loader:show', false);
	},
};
</script>

<style lang="less">
.test-radio {
	margin: 90px 0;

	.advanced-radio {
		.image-group {
			width: 70px;
			float: left;

			.image {
				width: auto;
				height: auto;
				max-height: 60px;
				max-width: 60px;
			}
		}
		.text {
			float: left;
			margin-left: 20px;
		}
		.radio-content {
			width: 100%;
			margin: 2px 0 !important;
			position: relative;

			label {
				width: 100%;
				font-weight: normal;
				font-size: 14px;
				padding: 1em !important;
				margin: 0;
				color: #616161;
				border-radius: 3px;
				text-transform: capitalize !important;
				font-weight: 600;
				border: solid 1px #efefef;
			}

			input[type='radio']:empty {
				display: none;
			}

			input[type='radio']:empty ~ label {
				line-height: 30px;
				cursor: pointer;
				-webkit-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
			}

			input[type='radio']:empty ~ label:before {
				position: absolute;
				display: block;
				top: -9px;
				bottom: 0;
				right: -9px;
				line-height: 30px;
				content: '';
				width: 30px;
				height: 30px;
				border: 3px solid #fff;
				background: #d1d3d4;
				border-radius: 50%;
				text-align: center;
			}

			input[type='radio']:hover:not(:checked) ~ label {
				color: #888;
			}

			input[type='radio']:hover:not(:checked) ~ label:before {
				content: '\2714';
				color: #c2c2c2;
			}

			input[type='radio']:focus ~ label:before {
				box-shadow: 0 0 0 3px #999;
			}

			input[type='radio']:checked ~ label {
				color: #777;
			}

			input[type='radio']:checked ~ label:before {
				content: '\2714';
				color: #333;
				background-color: #ccc;
			}

			input[type='radio']:checked ~ label {
				background-color: #b3c2c8;
				color: #484a57;
			}
		}

		.radio-content.radio-primary {
			input[type='radio']:checked ~ label:before {
				content: '\2714';
				color: var(--white);
				background-color: var(--primary);
			}
		}

		.radio-content.radio-success {
			input[type='radio']:checked ~ label:before {
				content: '\2714';
				color: var(--white);
				background-color: var(--success);
			}
		}

		.radio-content.radio-warning {
			input[type='radio']:checked ~ label:before {
				content: '\2714';
				color: var(--white);
				background-color: var(--warning);
			}
		}

		.radio-content.radio-danger {
			input[type='radio']:checked ~ label:before {
				content: '\2714';
				color: var(--white);
				background-color: var(--danger);
			}
		}
	}
}
</style>
